module.exports = __webpack_public_path__ + "img/04d.d1743056.png";